import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search bar to find students by <strong>name</strong>, <strong>email</strong>, <strong>ID</strong>, or <strong>country</strong>. Apply filters to refine your results." id="use_the_search_bar_to_find_students_by_n.a584164e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Students" id="searching_students.2e6d7001" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create Student</strong> to add a new student account. Enter their name, email, and any required details." id="click_create_student_to_add_a_new_studen.f2ffc95e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Student" id="creating_a_student.02e0560e" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select a student to view their profile. Use the tabs to see <strong>personal details</strong>, <strong>transaction history</strong>, <strong>group memberships</strong>, <strong>activity logs</strong>, and <strong>earned certificates</strong>." id="select_a_student_to_view_their_profile_u.5718530c" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Student Profile" id="student_profile.3914f618" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="The <strong>Certificates</strong> tab displays all credentials the student has earned, including exam results and completion records." id="the_certificates_tab_displays_all_creden.f2c7c643" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Certificates" id="certificates.03accec8" />
        }
    ],
    title: <FormattedMessage defaultMessage="Students" id="students.0933e5a0" />
};
